// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/fira_mono/FiraMono-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/fira_mono/FiraMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/raleway/Raleway-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/raleway/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/raleway/Raleway-Thin.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  font-family: var(--Raleway);
  font-weight: 400;

  color: var(--text-color0);
  background-color: var(--background-color0);
}

.Transition-1 {
  transition: all 500ms cubic-bezier(0.67, 0.01, 0.34, 0.99);
}

.Transition-2 {
  transition: all 600ms ease;
}

.scrollTransition {
  opacity: 0;
  transform: translateY(20px);
}

* {
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none!important;
  color: var(--accent-color2);
}

img {
  display: block;
  object-fit: contain;
}

button {
  border: none;
  background-color: transparent;
  cursor: pointer;
}

button:hover, input[type="submit"]:hover {
  filter: brightness(1.18);
}

button:active, input[type="submit"]:active {
  position: relative;
  transform: translateY(0.2rem);
  transition: none !important;
}

::selection {
  background-color: var(--accent-color0);
  color: white;
}

#root {
  --Raleway: 'Raleway', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  --Fira: "Fira Mono", monospace;
}

/* start scrollbar */
::-webkit-scrollbar {
  /* width: 0.875rem; */
  width: 1rem;
  height: 1.125rem;
  background-color: #19191e;
}

::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  height: 0.375rem;
  border: 0.25rem solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 0.5rem;
  background-color: #595964;
  box-shadow: inset -1px -1px 0px rgb(0 0 0 / 5%),
  inset 1px 1px 0px rgb(0 0 0 / 5%);
}

/* fonts */

/* Freight Big Pro */
@font-face {
  font-family: "Fira Mono";
  font-weight: 700;
  src: local("fira_mono"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      format("truetype");
}

@font-face {
  font-family: "Fira Mono";
  font-weight: 400;
  src: local("fira_mono"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format("truetype");
}

/* fonts */
@font-face {
  font-family: "Raleway";
  font-weight: 900;
  src: local("raleway"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      format("truetype");
}

@font-face {
  font-family: "Raleway";
  font-weight: 400;
  src: local("raleway"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___})
      format("truetype");
}

@font-face {
  font-family: "Raleway";
  font-weight: 200;
  src: local("raleway"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___})
      format("truetype");
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;;EAEhB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,iJAAiJ;EACjJ,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,4BAA4B;EAE5B,qBAAqB;EACrB,yBAAyB;EAGzB;mCACiC;AACnC;;AAEA,UAAU;;AAEV,oBAAoB;AACpB;EACE,wBAAwB;EACxB,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB;;wBAEsB;AACxB","sourcesContent":[".App {\n  font-family: var(--Raleway);\n  font-weight: 400;\n\n  color: var(--text-color0);\n  background-color: var(--background-color0);\n}\n\n.Transition-1 {\n  transition: all 500ms cubic-bezier(0.67, 0.01, 0.34, 0.99);\n}\n\n.Transition-2 {\n  transition: all 600ms ease;\n}\n\n.scrollTransition {\n  opacity: 0;\n  transform: translateY(20px);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  outline: 0;\n  box-sizing: border-box;\n}\n\na {\n  text-decoration: none!important;\n  color: var(--accent-color2);\n}\n\nimg {\n  display: block;\n  object-fit: contain;\n}\n\nbutton {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\nbutton:hover, input[type=\"submit\"]:hover {\n  filter: brightness(1.18);\n}\n\nbutton:active, input[type=\"submit\"]:active {\n  position: relative;\n  transform: translateY(0.2rem);\n  transition: none !important;\n}\n\n::selection {\n  background-color: var(--accent-color0);\n  color: white;\n}\n\n#root {\n  --Raleway: 'Raleway', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  --Fira: \"Fira Mono\", monospace;\n}\n\n/* start scrollbar */\n::-webkit-scrollbar {\n  /* width: 0.875rem; */\n  width: 1rem;\n  height: 1.125rem;\n  background-color: #19191e;\n}\n\n::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  height: 0.375rem;\n  border: 0.25rem solid rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  -webkit-border-radius: 0.438rem;\n  border-radius: 0.5rem;\n  background-color: #595964;\n  -webkit-box-shadow: inset -1px -1px 0px rgb(0 0 0 / 5%),\n  inset 1px 1px 0px rgb(0 0 0 / 5%);\n  box-shadow: inset -1px -1px 0px rgb(0 0 0 / 5%),\n  inset 1px 1px 0px rgb(0 0 0 / 5%);\n}\n\n/* fonts */\n\n/* Freight Big Pro */\n@font-face {\n  font-family: \"Fira Mono\";\n  font-weight: 700;\n  src: local(\"fira_mono\"),\n    url(\"./fonts/fira_mono/FiraMono-Bold.ttf\")\n      format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Fira Mono\";\n  font-weight: 400;\n  src: local(\"fira_mono\"),\n    url(\"./fonts/fira_mono/FiraMono-Regular.ttf\")\n      format(\"truetype\");\n}\n\n/* fonts */\n@font-face {\n  font-family: \"Raleway\";\n  font-weight: 900;\n  src: local(\"raleway\"),\n    url(\"./fonts/raleway/Raleway-Bold.ttf\")\n      format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Raleway\";\n  font-weight: 400;\n  src: local(\"raleway\"),\n    url(\"./fonts/raleway/Raleway-Regular.ttf\")\n      format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Raleway\";\n  font-weight: 200;\n  src: local(\"raleway\"),\n    url(\"./fonts/raleway/Raleway-Thin.ttf\")\n      format(\"truetype\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
